<ez-main-layout [landingpageConfig]="landingpageConfig" [theme]="Themes.NONE">
  <ez-banner>
    <span ngProjectAs="title">Ihre Zuzahlung</span>
    <span ngProjectAs="subtitle">Jetzt bequem und direkt zuzahlen</span>
  </ez-banner>

  <p>
    {{ landingpageConfig.organisation.customFields['insuranceInfoText'] | handlebars: landingpageConfig }}
  </p>

  <h3>
    Guten Tag, {{ landingpageConfig.customer.salutation }} {{ landingpageConfig.customer.title }}
    {{ landingpageConfig.customer.firstName }} {{ landingpageConfig.customer.lastName }},
  </h3>

  <p>
    {{ landingpageConfig.organisation.customFields['introductionText'] | handlebars: landingpageConfig }}
  </p>

  @if (landingpageConfig.organisation.customFields['showPolicyValue'] === 'true') {
    <ez-infobox aria-label="aktueller Policenwert">
      Ihr aktueller Policenwert per {{ landingpageConfig.insurance.policyValueRetrievedAt }} beträgt:
      {{ landingpageConfig.insurance.policyValue | currency: 'EUR' : 'code' : '1.2-2' }}
    </ez-infobox>
  }

  <h3>Jetzt einfach und bequem eine Zuzahlung wählen:</h3>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ez-slider
      [steps]="landingpageConfig.insurance.additionalPaymentOptions"
      #ezSlider
      (isEnabled)="onSliderEnabled()"
    />

    @if (hasSelectablePaymentMethod()) {
      <ez-expandable header="Oder Betrag individuell anpassen" (isDetailsOpen)="detailsOpened($event)">
        <p>Sie können den Betrag auch durch eine Eingabe in diesem Feld individuell festlegen</p>
        <input
          type="number"
          placeholder="gewünschten Betrag eingeben"
          formControlName="customAmount"
          step="any"
          [required]="isCustomAmountOpen"
          [min]="landingpageConfig.paymentConfiguration.minimumPaymentAmount"
          [max]="landingpageConfig.paymentConfiguration.maximumPaymentAmount"
        />
        @if (customAmountControl.invalid && (customAmountControl.dirty || customAmountControl.touched)) {
          @if (customAmountControl.hasError('required')) {
            <span class="error-message">Fehler: Dies ist ein Pflichtfeld. Bitte geben Sie einen Betrag an.</span>
          }
          @if (customAmountControl.hasError('min') || customAmountControl.hasError('max')) {
            <span class="error-message"
              >Fehler: Der Betrag muss zwischen
              {{ landingpageConfig.paymentConfiguration.minimumPaymentAmount | currency: 'EUR' : 'code' }} und
              {{ landingpageConfig.paymentConfiguration.maximumPaymentAmount | currency: 'EUR' : 'code' }} liegen.</span
            >
          }
        }
      </ez-expandable>

      <p>
        <span>Sie können den gewünschten Betrag</span>
        @if (landingpageConfig.organisation.customFields['showTaxInfo'] === 'true') {
          <span>**</span>
        }
        <span> durch Klick auf den 'Jetzt Bezahlen' Button einfach und bequem zuzahlen.</span>
      </p>

      <p>
        <b>Summe {{ selectedAmount | currency: 'EUR' : 'code' }}</b>
      </p>
    }

    <ez-payment-method-selection
      [paymentMethods]="paymentMethods"
      controlName="paymentMethod"
    ></ez-payment-method-selection>

    @if (hasSelectablePaymentMethod()) {
      <ez-button
        class="block--centered"
        buttonType="submit"
        maxWidth="300px"
        [disabled]="!(form && form.valid)"
        label="Jetzt bezahlen"
      ></ez-button>
    }
  </form>

  @if (hasManualPayment(landingpageConfig.paymentConfiguration)) {
    <ez-manual-payment
      [reasonForPayment]="landingpageConfig.reasonForPayment"
      [manualPaymentConfiguration]="landingpageConfig.paymentConfiguration.manualPaymentConfiguration"
    >
      @if (hasSelectablePaymentMethod()) {
        <span class="text--bold caption"
          >Alternativ können Sie Ihren individuellen Wunschbetrag auf das u.g. Konto überweisen:</span
        >
      } @else {
        <span class="text--bold caption"
          >Sie können Ihren individuellen Wunschbetrag auf das u.g. Konto überweisen:</span
        >
      }
      @if (landingpageConfig.organisation.customFields['showTaxInfo'] === 'true') {
        <p class="disclaimer">
          Um die steuerliche Anrechenbarkeit sicherzustellen, muss die Zuzahlung bis zum 31.12.2024 auf dem oben
          genannten Konto eingehen.
        </p>
      }
    </ez-manual-payment>
  }
  @if (landingpageConfig.organisation.customFields['showTaxInfo'] === 'true') {
    <p class="text--small">
      @if (hasSelectablePaymentMethod()) {
        <b>**</b>
      }
      Der steuerlich förderfähige Höchstbetrag in der Basisversorgung beträgt 2024 für einzeln Veranlagte 27.566 EUR und
      für zusammenveranlagte Ehegatten insgesamt 55.132 EUR.
    </p>
  }

  @if (landingpageConfig.organisation.customFields['showAdditionalInfo'] === 'true') {
    <p>
      <b>Allgemeiner Hinweis</b><br />

      Die Zuzahlung rechnen wir bei Überweisung bedingungsgemäß mit dem Kurs des Geldeingangsdatums bei R+V ein.
      Entscheiden Sie sich für eine Zuzahlung per SEPA-Lastschriftmandat, gilt der Kurs des vereinbarten
      Fälligkeitstermins.<br /><br />
      Den eingezahlten Betrag legen wir nach Entnahme der beitragsbezogenen Kosten nach aktuell festgelegter Aufteilung
      der Beiträge in sicheres Kapital und Chancen-Kapital an.<br /><br />

      <b>Steuerlicher Hinweis</b><br />

      Wird eine Kapitalleistung oder ein Rückkaufswert ausgezahlt, gehört der Unterschiedsbetrag zwischen der
      Versicherungsleistung und der Summe der auf sie entrichteten Beiträge zu den zu versteuernden Einkünften aus
      Kapitalvermögen. Wird die Leistung nach Vollendung des 62. Lebensjahres und nach Ablauf von 12 Jahren seit dem
      Vertragsabschluss ausgezahlt, ist nur die Hälfte des Unterschiedsbetrags anzusetzen. <br /><br />
      Die Zuzahlung kann zu einer steuerlichen Novation Ihres Vertrages führen, wodurch der auf den Erhöhungsteil
      entfallende Ertrag bei Auszahlung der Leistung in voller Höhe zu versteuern wäre. Nähere Information erhalten Sie
      bei Ihrem Steuerberater oder Ihrem zuständigen Finanzamt.
    </p>
  }

  <ez-contact
    [organisation]="landingpageConfig.organisation"
    teaserShort="Sie möchten noch Fragen mit uns klären?"
    phonePrefix="Rufen Sie uns gerne an: "
    subtitle="Kundenservice"
    withContactForm="false"
  ></ez-contact>
</ez-main-layout>
